/** Rodzaj pozycji słownika kadrowego (BE: Data.Workspace.WorkspaceJobTitleKind). */
export enum EWorkspaceJobTitleKind {
  /** Stopień służbowy — przypisywany członkowi w metryce. */
  Grade = 0,
  /** Stanowisko służbowe — podpowiedź dla stanowiska członka (tekst). */
  Position = 1,
}

export interface IWorkspaceJobTitle {
  Id: string;
  Kind: EWorkspaceJobTitleKind;
  Name: string;
  IsArchived: boolean;
  /** Ilu członków używa pozycji — takiego stopnia nie da się usunąć, tylko zarchiwizować. */
  UsageCount: number;
}

export interface IWorkspaceJobTitlesResponse {
  Items: IWorkspaceJobTitle[];
  /** Stanowiska wpisane członkom, których nie ma w słowniku („ze struktury", tylko odczyt). */
  PositionsInUse: string[];
  /** Właściciel albo zarządzający zespołem (EditMembers). */
  CanEdit: boolean;
}

export interface ISaveWorkspaceJobTitle {
  /** Brak = nowa pozycja. */
  Id?: string;
  Kind: EWorkspaceJobTitleKind;
  Name: string;
  IsArchived: boolean;
}
